export const RESOURCES = '/resources'
export const POSITIONS = '/positions'
export const REGISTRATION = '/registration'
export const REGISTRATION1 = '/'
export const LOGIN = '/login'
export const RESETPASSWORD = '/resetpassword'
export const VERIFICATION = '/verification'
export const APPLIEDCANDIDATES = '/position-details'
export const APPLYPOSITION = '/applypositions'
export const COMPANYSETTINGS = '/settings'
export const CREATERESOURCES = '/createResources'
export const INCONTRACTRESOURCES = '/incontract'
export const TIMESHEET = '/timesheet'
export const ADDTIMESHEET = '/addTimesheet'
export const FORGOTPASSWORD = '/forgotpassword'
export const APPLYRESOURCE = '/applyresource'